import { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@bonusly/design-system';
import { useBuildMonarchURL } from '@bonusly/url';

import { AppPath } from '../../config/router';
import { useIsRecognize } from '../../hooks/useIsRecognize';

export const GoHomeButton: FC = () => {
	const { t } = useTranslation('vertical_navbar');
	const isRecognize = useIsRecognize();
	const monarchURL = useBuildMonarchURL();

	// Home is always on Monarch
	const homeUrl = isRecognize ? monarchURL(AppPath.Home) : AppPath.Home;

	// Handle click for cross-domain navigation
	const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
		if (isRecognize) {
			e.preventDefault();
			window.location.href = homeUrl;
		}
	};

	return (
		<Button as={Link} to={homeUrl} onClick={handleClick} colorScheme="primary" variant="alpha" mx={2} mb={3} display="flex" data-testid="go-home-button">
			{t('admin_menu.go_home')}
		</Button>
	);
};
